<template>
	<div class="tabs is-toggle">
		<ul>
			<li
				:class="{ 'is-active': value === 'overview' }"
				@click="$emit('input', 'overview')"
			>
					<a>
						<p>{{ $t('statistics.new_statistics') }}</p>
					</a>
			</li>
			<li
				:class="{ 'is-active': value === 'legacy' }"
				@click="$emit('input', 'legacy')"
			>
					<a>
						<p>{{ $t('statistics.old_statistics') }}</p>
					</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'StatisticsTabs',

	props: {
		value: {
			type: String,
			required: true
		}
	}
};
</script>
